// Design tokens shared with Plankton CRM (brand teal #427898, slate text scale).
export const ACCENT = '#427898';
export const ACCENT_DARK = '#356382';
export const ACCENT_GRAD = 'linear-gradient(135deg, #4e90b5 0%, #427898 100%)';
export const TEXT = '#1a2332';
export const TEXT_MUTED = '#64748B';
export const TEXT_FAINT = '#94A3B8';
export const BORDER = '#E2E8F0';
export const BORDER_SOFT = '#EEF2F6';
export const SURFACE_MUTED = '#F8FAFC';

export const STATUS = {
    RECEIVED:    { color: '#4A90E2', bg: 'rgba(74,144,226,0.10)' },
    IN_PROGRESS: { color: '#F59E0B', bg: 'rgba(245,158,11,0.12)' },
    DONE:        { color: '#10B981', bg: 'rgba(16,185,129,0.12)' },
};
export const STATUS_ORDER = ['RECEIVED', 'IN_PROGRESS', 'DONE'];

export const QUOTE_STATUS = {
    DRAFT:    { color: '#64748B', bg: '#F1F5F9' },
    SENT:     { color: '#4A90E2', bg: 'rgba(74,144,226,0.10)' },
    ACCEPTED: { color: '#10B981', bg: 'rgba(16,185,129,0.12)' },
    REJECTED: { color: '#EF4444', bg: 'rgba(239,68,68,0.10)' },
};
export const QUOTE_STATUS_ORDER = ['DRAFT', 'SENT', 'ACCEPTED', 'REJECTED'];

export const CATEGORY_COLORS = ['#427898', '#2EC4B6', '#F4A261', '#8B5CF6', '#10B981', '#EF4444', '#EC4899', '#0EA5E9', '#84CC16', '#64748B'];

export const cardSx = {
    bgcolor: '#fff',
    border: `1px solid ${BORDER}`,
    borderRadius: '14px',
};
